import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import Blog from '../components/Blog';

const BlogPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Knowledge Hub - Adept Knowledge Technologies</title>
        <meta name="description" content="Explore research insights, industry articles, and updates from Adept Knowledge Technologies on AI-driven livestock health, mastitis detection, dairy sustainability, and precision diagnostics." />
        <link rel="canonical" href="https://www.ak-tech.in/knowledge-hub" />
        <meta property="og:title" content="Knowledge Hub - Adept Knowledge Technologies" />
        <meta property="og:description" content="Research insights and industry updates on AI-driven livestock health, mastitis detection, and dairy sustainability." />
        <meta property="og:url" content="https://www.ak-tech.in/knowledge-hub" />
        <meta name="twitter:title" content="Knowledge Hub - Adept Knowledge Technologies" />
        <meta name="twitter:description" content="Research insights and industry updates on AI-driven livestock health, mastitis detection, and dairy sustainability." />
      </Helmet>
      <Blog />
    </Layout>
  );
};

export default BlogPage;